import React, { Component } from 'react';
import Enums from '../../enums';
import { Container, Row, Col, Button } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import { FaSortDown, FaSortUp, FaSort } from 'react-icons/fa';
import { CSVLink } from "react-csv";
import '../../css/ListView.scss';

class ListView extends Component {
    /*
    <ListView list={list} 
        fields={fields}
        onRowClicked={onListViewClicked}/>
    fields:
        ["a","b",...]
    list:
        [
            {
                key: "a key",
                data: [
                    a list
                ]
            }, {
                key: "b key",
                data: [b list]
            },
            ...
        ]
    */

    constructor(props) {
        super();

        // console.log(props.sort_index);
        this.state = {
            showRows: 20,
            currentPage: 0,
            sort_index: props.sort_index || -1,
            ascending: typeof (props.ascending) == "boolean" ? props.ascending : true,
            filter: null,
            export_rows: [],
            isWaitingForUpdate: true,
            downloadLinkReady: false,
            isRowDownloadable: null==props.isRowDownloadable ? false : props.isRowDownloadable,
            isHeaderDownloadable: null==props.isHeaderDownloadable ? false : props.isHeaderDownloadable,
            isAnserRecordDownloadable: null==props.isAnserRecordDownloadable ? false : props.isAnserRecordDownloadable,
        };
        this.onClick = this.onClick.bind(this);
        this.onShowRowChange = this.onShowRowChange.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onHeaderClick = this.onHeaderClick.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.genDownloadLink = this.genDownloadLink.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log("[componentDidUpdate]", this.state.isWaitingForUpdate)
        // console.log(prevProps.list, this.props.list)
        if ((true == this.state.isWaitingForUpdate
            && prevProps.list == null || prevProps.list.length == 0)
            && this.props.list != null && this.props.list.length > 0) {
            // console.log("!!");
            this.setState({ isWaitingForUpdate: false })
            this.genDownloadLink();
        }
    }

    onClick(e) {
        // Skip if click originated from a button or link inside the row
        if (e.target.closest && e.target.closest('button, a')) return;
        const selectedIndex = e.target.getAttribute('data-item');
        if( selectedIndex && this.props.onRowClicked ){
            this.props.onRowClicked(selectedIndex);
        }
    }

    onShowRowChange(e) {
        const tmp = parseInt(e.target.value);
        this.setState({ showRows: tmp, currentPage: 0 });
    }

    onPageChange(e) {
        const tmp = parseInt(e.target.value);
        this.setState({ currentPage: tmp });
    }

    onHeaderClick(e) {
        const selectedIndex = e.target.getAttribute('data-k');
        if (selectedIndex === this.state.sort_index) {
            this.setState({ ascending: !this.state.ascending });
        } else {
            this.setState({ sort_index: selectedIndex });
        }
    }

    propComparator(index, asc) {
        if (asc) {
            return function (a, b) {
                if (a.data[index] === b.data[index]) return 0;
                if (a.data[index] > b.data[index]) return 1;
                return -1;
            }
        }
        return function (a, b) {
            if (a.data[index] === b.data[index]) return 0;
            if (a.data[index] < b.data[index]) return 1;
            return -1;
        }
    }

    propComparatorInt(index, asc) {
        if (asc) {
            return function (a, b) {
                var a = parseInt(a.data[index]);
                var b = parseInt(b.data[index]);
                if (a === b) return 0;
                if (a > b) return 1;
                return -1;
            }
        }
        return function (a, b) {
            var a = parseInt(a.data[index]);
            var b = parseInt(b.data[index]);
            if (a === b) return 0;
            if (a < b) return 1;
            return -1;
        }
    }

    onFilterChange(e) {
        // console.log( e.target.value );
        if (0 === e.target.value.length) {
            this.setState({ filter: null });
        } else {
            this.setState({ filter: e.target.value });
        }
    }

    filterFunc(filter) {
        return function (item, index, array) {
            return item.data.join().indexOf(filter) >= 0;
        }
    }

    genDownloadLink() {
        // console.log("[!]", this, this.props);
        if (!this || !this.props ) {
            console.log("[!] no props");
            return;
        }
        if (false==this.state.isHeaderDownloadable 
            && false==this.state.isRowDownloadable) {
            this.setState({
                export_rows: [],
                // isWaitingForUpdate: false
                downloadLinkReady: true
            });
            return;
        }

        let { list, hideIndexList } = this.props;
        const export_rows = [];
        // download all data in once
        for (let i = 0; i < list.length; i++) {
            const obj = list[i],
                ary = obj.data,
                row = [];
            for (let j in ary) {
                let isHide = false;
                try {
                    if (true == hideIndexList[j]) isHide = true;
                } catch (e) {
                    console.log(e.stack);
                }

                if (false == isHide) {
                    row.push(ary[j]);
                }
            }
            export_rows.push(row);
        }

        // console.log("[!]", export_rows);

        this.setState({
            export_rows: export_rows,
            // isWaitingForUpdate: false
            downloadLinkReady: true
        });
    }

    render() {
        // console.log(this.props);
        let { list, fields, title, sort_type, hideIndexList, renderDownload, renderRecordDownload, renderCopy } = this.props,
            { showRows, currentPage, sort_index, ascending
                , filter, export_rows, downloadLinkReady, isHeaderDownloadable, isRowDownloadable, isAnserRecordDownloadable } = this.state;
        const { onClick, onShowRowChange, onPageChange, onHeaderClick,
            onFilterChange, filterFunc, propComparator, propComparatorInt } = this;
        const option_ary = [20, 100, 500, 1000];
        // console.log(showRows);

        if (null == list || null == list.length || 0 >= list.length) {
            return (<label>No Data</label>);
        }

        try {
            if (filter) {
                list = list.filter(filterFunc(filter));
            }

            if (sort_index >= 0) {
                if (sort_type) {
                    switch (sort_type[sort_index]) {
                        case Enums.ESORT.NONE:
                            break;
                        case Enums.ESORT.NUM:
                            list.sort(propComparatorInt(sort_index, ascending));
                            break;
                        default:
                            list.sort(propComparator(sort_index, ascending));
                            break;
                    }
                } else {
                    list.sort(propComparator(sort_index, ascending));
                }
            }

            // const export_rows = [];
            const export_header_tmp = [];
            const t_headers = [];
            for (const index in fields) {
                let isHide = false;
                try {
                    if (true == hideIndexList[index]) isHide = true;
                } catch (e) {

                }

                if (false == isHide) {
                    if (sort_index == index) {
                        if (true == ascending) {
                            t_headers.push(<th key={index} data-k={index} onClick={onHeaderClick}>{fields[index]}&nbsp;<FaSortDown /></th>);
                        } else {
                            t_headers.push(<th key={index} data-k={index} onClick={onHeaderClick}>{fields[index]}&nbsp;<FaSortUp /></th>);
                        }
                    } else {
                        t_headers.push(<th key={index} data-k={index} onClick={onHeaderClick}>{fields[index]} &nbsp;<FaSort /></th>);
                    }
                    export_header_tmp.push(fields[index]);
                }
            }
            if (null != renderDownload && true==isRowDownloadable) {
                t_headers.push(<th key={-1}>下載</th>)
                export_header_tmp.push("下載");
            }
            if (null != renderRecordDownload && true==isAnserRecordDownloadable) {
                t_headers.push(<th key={-1}>下載</th>)
                export_header_tmp.push("下載");
            }
            if (null != renderCopy) {
                t_headers.push(<th key={-2}>複製</th>);
            }
            export_rows.push(export_header_tmp);

            const options = [];
            for (let index in option_ary) {
                const val = option_ary[index];
                options.push(<option key={val} value={val}>{val}</option>);
            }

            let pageCnt = 0,
                index_min = -1,
                index_max = 0;
            let t_body = [], pages = [];
            let filename = this.props.fileName ? this.props.fileName + ".csv" : "ezc_export_" + new Date().toISOString().slice(0, 10) + ".csv";

            if (list.length > 0) {
                const mod = list.length % showRows;

                pageCnt = (mod === 0) ? Math.floor(list.length / showRows) : Math.floor(list.length / showRows) + 1;
                index_min = currentPage * showRows;
                index_max = Math.min((currentPage + 1) * showRows, list.length);

                for (let i = index_min; i < index_max; i++) {
                    const obj = list[i],
                        ary = obj.data,
                        tds = [],
                        tmpKey = obj.key;
                    for (let j in ary) {
                        let isHide = false;
                        try {
                            if (true == hideIndexList[j]) isHide = true;
                        } catch (e) { }

                        if (false == isHide) {
                            tds.push(<td key={j} data-item={tmpKey}>{ary[j]}</td>);
                        }
                    }
                    if (null != renderDownload) {
                        if(false == isRowDownloadable) tds.push(<td key={-1} data-item={tmpKey}></td>);
                        else tds.push(<td key={-1}>{renderDownload(tmpKey, ary)}</td>);
                    }
                    if (null != renderRecordDownload ){
                        if(true==isAnserRecordDownloadable){
                            tds.push(<td key={-1}>{renderRecordDownload(tmpKey, ary)}</td>);
                        }
                    }
                    if (null != renderCopy) {
                        tds.push(<td key={-2}>{renderCopy(tmpKey)}</td>);
                    }
                    t_body.push(<tr key={i} data-item={tmpKey} onClick={onClick}>{tds}</tr>);
                }

                for (let i = 0; i < pageCnt; i++) {
                    pages.push(<option key={i} value={i}>{i + 1}</option>);
                }


                // download all data in once
                // for (let i = 0; i < list.length; i++) {
                //     const obj = list[i],
                //         ary = obj.data,
                //         row = [];
                //     for (let j in ary) {
                //         let isHide = false;
                //         try {
                //             if (true == hideIndexList[j]) isHide = true;
                //         } catch (e) {

                //         }

                //         if (false == isHide) {
                //             row.push(ary[j]);
                //         }
                //     }
                //     export_rows.push(row);
                // }
            }
            // console.log(t_body);

            //header download btn
            let download_button = null;
            if(false == isHeaderDownloadable){
                download_button = null;
            } else {
                download_button = (
                    <Button variant="outline-primary" size="sm" disabled={!downloadLinkReady}>
                        {downloadLinkReady ? (
                            <span className="glyphicon glyphicon-download-alt">
                                {/* <Link to={download_uri}>Download</Link> */}
                                <CSVLink disabled={export_rows != null}
                                    headers={export_header_tmp}
                                    data={export_rows}
                                    filename={filename}>Download
                                </CSVLink>
                            </span>
                        ) : (
                            <span className="glyphicon glyphicon-download-alt">Loading..</span>
                        )}
                    </Button>
                );
            }

            return (
                <Container className="list-view">
                    <Row className="mt-5 mb-3">
                        <Col sm={6}>
                            <h2>{title}&nbsp;
                                {download_button}
                            </h2>
                        </Col>
                        <Col sm={6} className="justify-content-end">
                            <form className="form-inline justify-content-end mr-3">
                                <div className="form-group">
                                    <label>顯示幾項&nbsp;</label>
                                    <select className="form-control" value={showRows} onChange={onShowRowChange}>
                                        {options}
                                    </select>
                                </div>&nbsp;
                                <div className="form-group">
                                    <label>搜尋&nbsp;</label>
                                    <input type="text" className="form-control" placeholder="搜尋內容" onChange={onFilterChange} />
                                </div>
                            </form>
                        </Col>
                    </Row>
                    <div className="row table-container">
                        <table className="table table-hover">
                            <thead><tr>{t_headers}</tr></thead>
                            <tbody>{t_body}</tbody>
                        </table>
                    </div>
                    <div className="row">
                        <div className="col-9">
                            Showing {index_min + 1} to {index_max} of {list.length} entries
                        </div>
                        <div className="col-3 text-right">
                            <form className="form-inline">
                                <div className="form-group">
                                    <label>到第幾頁&nbsp;</label>
                                    <select className="form-control" value={currentPage} onChange={onPageChange}>
                                        {pages}
                                    </select>
                                </div>&nbsp;
                            </form>
                        </div>
                    </div>
                </Container>
            );
        } catch (e) {
            console.log(e);
            return (<div>error</div>);
        }
    }
}

export default ListView;